<title>Visio Messaging XML - {{versaoSistema}}</title>
<div class="d-flex">
  <app-menu [usuarioAutenticado]="usuarioAutenticado" class="h-100 no-print col-2 h-100" id="sidebar-menu"></app-menu>

  <div class="d-flex flex-column w-100">
    <app-header class="no-print" [usuarioAutenticado]="usuarioAutenticado" [usuarioLogado]="usuarioLogado"></app-header>
    
    <section class="container-fluid mt-5 py-2 menu-section">
      <router-outlet></router-outlet>
    </section>
    <app-toolbar [usuarioAutenticadoP]="usuarioAutenticado" class="no-print"></app-toolbar>
  </div>
</div>
<app-loading [show]="apiLoading.loading$ | async"></app-loading>
<app-error-popup></app-error-popup>